module.exports = __webpack_public_path__ + "static/img/book.7963713.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/book.png
// module id = FCiL
// module chunks = 1